import { MetricValue } from "@/components/marketing/MetricValue";
import { reasonText } from "@/lib/marketing";

const Change = ({ current, prior, format }) => {
  const a = current && typeof current === "object" ? current.value : current;
  const b = prior && typeof prior === "object" ? prior.value : prior;
  if (a === null || a === undefined || b === null || b === undefined || b === 0) {
    return <p className="text-[11px] text-slate-400 mt-1">No comparable prior period</p>;
  }
  const delta = Number(a) - Number(b);
  const change = Math.round((delta / Math.abs(Number(b))) * 1000) / 10;
  const tone = delta >= 0 ? "text-emerald-600" : "text-rose-600";
  return (
    <p className={`text-[11px] mt-1 font-semibold ${tone}`}>
      {delta >= 0 ? "▲" : "▼"} {change}% vs prior ({format ? format(b) : b})
    </p>
  );
};

/** Headline KPI tile. Formula/reason always explained on hover. */
export const KpiCard = ({ label, metric, prior, format, hint, testid, tone = "" }) => (
  <div data-testid={testid}
    className={`rounded-2xl border border-slate-200 bg-white p-4 sm:p-5 shadow-sm
      transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-md ${tone}`}>
    <p className="text-[11px] uppercase tracking-wider font-bold text-slate-500">{label}</p>
    <p className="text-2xl sm:text-3xl font-black text-slate-900 mt-1">
      <MetricValue metric={metric} format={format} testid={`${testid}-value`} />
    </p>
    {(metric?.formula || hint) && (
      <p className="text-[11px] text-slate-500 mt-1">{metric?.formula || hint}</p>
    )}
    {metric && metric.value === null && metric.reason && (
      <p className="text-[11px] text-amber-700 mt-1">{reasonText(metric.reason)}</p>
    )}
    {prior !== undefined && <Change current={metric} prior={prior} format={format} />}
  </div>
);
